<template>
  <div v-if="isAdmin" class="bg-secondary p-16 rounded">
    <div class="card-box mt-16 sm:mx-16">
      <div
        class="flex justify-between flex-wrap pb-0 company-tab items-baseline"
      >
        <portal-target name="dashboard-header" />
        <div class="flex gap-x-20 sm:gap-x-3">
          <base-button
            v-if="
              activeTab !== 'data' &&
              activeTab !== 'message'
            "
            buttonType="primary"
            width="110"
            height="40"
            class="sm:w-90"
            radius="default"
            :hasIcon="true"
            @click.native="AddButtonHandler()"
          >
            <template #text>
              <span class="text-14">
                {{ $t('add') }}
              </span>
            </template>
            <template #icon>
              <img :src="Add" alt="add" class="mx-3" />
            </template>
          </base-button>
          <base-simple-search-box
            v-if="activeTab !== 'data' && activeTab !== 'message'"
            id="s_dashboard"
            @searchedText="getSearchedText"
            @searchedIn="getSearchedType"
            customStyle="sm:w-52 text-title"
            width="210"
            height="40"
            :type="activeTab"
          />
        </div>
      </div>
    </div>
    <base-tab :tabList="tabList" data-cy="tab-data">
      <template #tabPanel-companies>
        <admin-panel type="companies" :searchedText="adminSearchedText" />
      </template>
      <template #tabPanel-users>
        <admin-panel type="users" :searchedText="adminSearchedText" />
      </template>
      <template #tabPanel-serial_numbers>
        <admin-panel type="serial-numbers" :searchedText="adminSearchedText" />
      </template>
      <template #tabPanel-platforms>
        <admin-panel type="platforms" :searchedText="adminSearchedText" />
      </template>
      <template #tabPanel-logs>
        <admin-panel type="logs" :searchedText="adminSearchedText" />
      </template>
      <template #tabPanel-data>
        <admin-data />
      </template>
      <template #tabPanel-message>
        <admin-message />
      </template>
    </base-tab>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTab from '@/components/base/BaseTab.vue';
import AdminData from '@/components/admin/dashboard/AdminData.vue';
import AdminMessage from '@/components/admin/dashboard/AdminMessage.vue';
import AdminPanel from '@/components/admin/dashboard/AdminPanel.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import BaseSimpleSearchBox from '@/components/base/BaseSimpleSearchBox.vue';
import EventBus from '@/utils/EventBus';
import Add from '@/assets/icons/svg/white-add.svg';

export default {
  components: {
    BaseTab,
    AdminData,
    AdminMessage,
    AdminPanel,
    BaseButton,
    BaseSimpleSearchBox,
  },
  data() {
    return {
      tabList: ['companies', 'users', 'serial_numbers', 'platforms', 'logs', 'data', 'message'],
      adminSearchedText: '',
      searchType: '',
      isSearching: false,
      Add,
      activeTab: this.$route.query.active,
    };
  },
  watch: {
    $route(newRoute) {
      this.activeTab = newRoute.query.active;
      EventBus.$emit('emptyInputValue');
    },
  },
  computed: {
    ...mapGetters({
      defaultCompany: 'getDefaultCompany',
      currentPermission: 'permissions/getPermissions',
    }),
    isAdmin() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user && user.is_admin ? user.is_admin : false;
    },
  },
  methods: {
    hasPermission(permission) {
      return !!(this.currentPermission && this.currentPermission.includes(permission));
    },
    getSearchedType(type) {
      this.searchType = type;
    },
    getSearchedText(text) {
      this.adminSearchedText = text;
      this.isSearching = !!(text && text !== '');
    },
    AddButtonHandler() {
      EventBus.$emit('AdminAddButton');
    },
  },
};
</script>

<style></style>
